/**
 * Vehicle Type Model for FlowRide Frontend
 * Defines the different types of vehicles supported in the system.
 */

/** Enumeration of supported vehicle types */
export enum VehicleType {

    "Bus" = "bus",
    "Tram" = "tram",
    "Car" = "car",
    "Trolleybus" = "trolleybus",
    "Water" = "water",
    "Ferry" = "ferry",
    "Taxi" = "taxi",
    "Funicular" = "funicular",
    "Train" = "train",

    /** Urban Railway vehicle type (metro, underground, etc.) */
    "UrbanRailway" = "urbanRailway",
}
